import { Outlet, createFileRoute } from "@tanstack/react-router";

/**
 * A sibling of `_app`, not a child, for `use-cases.tsx`'s reason: these pages
 * are public and `_app`'s guard would bounce an anonymous reader to sign-in.
 *
 * The layout itself carries nothing, as that one does not. `UseCaseCategoryPage`
 * mounts the shell, the header and the footer per page, and its opening section
 * carries the full break, so the fixed bar needs no clearing in flow, a layout
 * adding one here would drop every page a bar-height below the published one.
 */
export const Route = createFileRoute("/use-cases-categories")({
  component: Outlet,
});
